module.exports = __webpack_public_path__ + "img/explicae-redacao.f5a84f16.png";